import { User, UserInterface } from 'app/core/user/models';
import { stringDecodeToHtml } from 'app/shared/utilities/utility-methods.utility';
import { CommentInterface } from 'app/task/models/comment.model';

import { RecommendationCategoryMultiInterface } from './recommendation-category-multi.model';
import { recommendationItemMullangInterface } from './recommendation-item-multi.model';

export interface RecommendationInterface {
  comments?: CommentInterface[];
  completedBy?: UserInterface;
  completedDate?: Date;
  createdBy?: UserInterface;
  id?: number;
  isComplete?: boolean;
  name?: string;
  priority?: number;
  priorityText?: string;
  recommendationCategoryMullang?: RecommendationCategoryMultiInterface[];
  parentRecommendationId?: number;
  parentRecommendationCategoryTitle?: string;
  recommendationMullang?: recommendationItemMullangInterface[];
  recommendationDate?: Date;
  imageFileName?: string;
  subject?: UserInterface;
  text?: string;
  ergoDetails?: string;
  detailsAsHtml?: string;
  textAsHtml?: string;
  textAsPlainText?: string;
  title?: string;
  relatedAssessmentId?: number;
  relatedAssessmentType?: string;
  daysOpen?: number;
  isEdited?:boolean;
}

export class Recommendation implements RecommendationInterface {
  public comments?: CommentInterface[];
  public completedBy?: UserInterface;
  public completedDate?: Date;
  public createdBy?: UserInterface;
  public id?: number;
  public isComplete?: boolean;
  public recommendationCategoryMullang?: RecommendationCategoryMultiInterface[];
  public recommendationMullang?: recommendationItemMullangInterface[];
  public name?: string;
  public priority?: number;
  public priorityText?: string;
  public parentRecommendationId?: number;
  public parentRecommendationCategoryTitle?: string;
  public recommendationDate?: Date;
  public imageFileName?: string;
  public subject?: UserInterface;
  public text?: string;
  public ergoDetails?: string;
  public title?: string;
  public relatedAssessmentId?: number;
  public relatedAssessmentType?: string;
  public daysOpen?: number;
  public isEdited?:boolean;

  constructor({
    comments = undefined,
    completedBy = undefined,
    completedDate = undefined,
    createdBy = undefined,
    id = undefined,
    isComplete = undefined,
    name = undefined,
    recommendationCategoryMullang = undefined,
    priority = undefined,
    priorityText = undefined,
    parentRecommendationId = undefined,
    parentRecommendationCategoryTitle = undefined,
    recommendationDate = undefined,
    imageFileName = undefined,
    subject = undefined,
    text = undefined,
    ergoDetails = undefined,
    title = undefined,
    relatedAssessmentId = undefined,
    relatedAssessmentType = undefined,
    daysOpen = undefined,
    isEdited = undefined,
    recommendationMullang = undefined,
    }: RecommendationInterface) {
    this.completedBy = completedBy ? new User(completedBy) : undefined;
    this.completedDate = completedDate;
    this.createdBy = createdBy ? new User(createdBy) : undefined;
    this.recommendationCategoryMullang = recommendationCategoryMullang;
    this.recommendationMullang = recommendationMullang;
    this.id = id;
    this.isComplete = isComplete;
    this.name = name;
    this.priority = priority;
    this.priorityText = priorityText;
    this.parentRecommendationId = parentRecommendationId;
    this.parentRecommendationCategoryTitle = parentRecommendationCategoryTitle;
    this.recommendationDate = recommendationDate;
    this.imageFileName = imageFileName;
    this.subject = subject ? new User(subject) : undefined;
    this.text = text;
    this.ergoDetails = ergoDetails;
    this.title = title;
    this.relatedAssessmentId = relatedAssessmentId;
    this.relatedAssessmentType = relatedAssessmentType;
    this.daysOpen = daysOpen;
    this.isEdited = isEdited;
  }

  get textAsHtml(): string {
    return stringDecodeToHtml(this.text);
  }

  get textAsPlainText(): string {
    return this.stringDecodeToPlainText(this.text);
  }

  get detailsAsHtml(): string {
    return stringDecodeToHtml(this.ergoDetails);
  }

  private stringDecodeToPlainText(stringToDecode: string): string {
    let textAsPlainText: string;
    if (stringToDecode) {
      // very hacky, but from Google searching this approach was recommended the most:
      // https://stackoverflow.com/questions/17289448/angularjs-to-output-plain-text-instead-of-html
      textAsPlainText = String(window.atob(stringToDecode)).replace(/<[^>]+>/gm, '');
    } else {
      textAsPlainText = undefined;
    }
    return textAsPlainText;
  }
}
